import React from 'react';
import { createPortal } from 'react-dom';

import { colorToString, injectAktivFallback } from '../widgets/widget.helper';
import get from 'lodash/get';
import size from 'lodash/size';


function BrandThemeManager({ className, themes }) {
  if (size(themes) === 0) {
    return false;
  }
  const cssRules = themes.map(theme => {
    const format = get(theme, 'type');
    const fontSize = get(theme, 'font.fontSize');
    const fontFamily = get(theme, 'font.fontFamily');
    const color = get(theme, 'font.color');

    return (
      `${className} ${format} {
        font-size: ${fontSize}px;
        font-family: ${injectAktivFallback(fontFamily)};
        color: ${colorToString(color)};
      }`
    );
  }).join('');
  
  return createPortal(
    <style dangerouslySetInnerHTML={{ __html: cssRules }} />,
    document.head
  );
}

export default BrandThemeManager;